package com.example.mystybag.pdf.logic

import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.expected.openSettings
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.core.model.AdditionalIcon
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.core.expected.sharedActivity
import com.example.mystybag.pdf.helpers.showStoragePermissionDeniedDialog
import com.example.mystybag.pdf.model.PdfUrlUIState
import com.example.mystybag.pdfUtils.expected.PDFHelper
import com.example.mystybag.pdfUtils.expected.copyToExternalDisk
import com.example.mystybag.pdfUtils.expected.sharePDF
import com.example.mystybag.permissionsUtils.expected.Permission
import com.example.mystybag.permissionsUtils.expected.PermissionHelper
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

class PdfUrlViewModel(
    context     : AppContext,
    val url     : String,
    val title   : String,
    withSave    : Boolean
): ChildViewModel<PdfUrlUIState>(context, PdfUrlUIState(isDownloadButtonVisible = withSave)) {

    override fun onCreate() {
        showProgress(true)

        scope.launch {
            delay(500) //This delay fixes view disappearing issue, investigate why
            PDFHelper().downloadFile(url, "$title.pdf")?.also { file ->
                showProgress(false)
                launchOnMain {
                    updateState { it.copy(pdfFile = file) }
                    navControls.additionalIcons = listOf(
                        AdditionalIcon(
                            image   = SRC.images.print_icon,
                            action  = { PDFHelper().printFile("$title.pdf", uiState.value.pdfFile) }
                        ),
                        AdditionalIcon(
                            image   = SRC.images.share_icon,
                            action  = ::sharePdf
                        )
                    )
                }
            } ?: onLoadError()
        }
    }

    fun onLoadError() {
        showProgress(false)
        showSnackbar(SR.strings.an_error_occurred_please_try_again_later)
        goBack()
    }

    fun onPageSelected(currentPage: Int, pagesCount: Int) {
        navControls.title = "${currentPage + 1}/$pagesCount"
    }

    private fun downloadPdf() {
        val file = uiState.value.pdfFile
        if (file != null && file.copyToExternalDisk("$title.pdf"))
            showSnackbar(SR.strings.successfully_saved_to_device)
        else
            showSnackbar(SR.strings.download_failed)
    }

    private fun showPermissionDialog() {
        uiThread {
            showStoragePermissionDeniedDialog(
                sharedString(SR.strings.storage_permission),
                sharedString(SR.strings.settings),
                sharedString(SR.strings.cancel)
            ) {
                openSettings()
            }
        }
    }

    fun onDownloadButtonClicked() {
        launchOnMain {
            if (PermissionHelper.requestPermission(Permission.WriteExternalStorage, sharedActivity))
                downloadPdf()
            else
                showPermissionDialog()
        }
    }

    private fun sharePdf() {
        uiState.value.pdfFile?.let { file ->
            sharePDF(file, "$title.pdf")
        }
    }

    fun onPageLoaded(currentPage: Int, pagesCount: Int) {
        onPageSelected(currentPage, pagesCount)
        showProgress(false)
    }
}